import React from 'react'
import styled from 'styled-components';
import WaveSection from './WaveSection'
import { useTranslation } from 'react-i18next'
import {Button} from './Button'
import {navigate} from "gatsby"

const CTA = (props) => {
  const { t } = useTranslation()
  const {
    text = t('root.ctaText-1'),
    buttonText = t('root.ctaButton-1'),
    buttonLink = t('translations:urls.register')
  } = props

  return (
    <WaveSection>
      <Wrapper>
        <HeaderTitle dangerouslySetInnerHTML={{ __html: text}}></HeaderTitle>
        <Button onClick={() => navigate(buttonLink)}>{buttonText}</Button>
      </Wrapper>
    </WaveSection>
  )
}

export default CTA


const HeaderTitle = styled.h2`
  font-size: 3rem;
  text-align:center;
  @media (max-width: 600px) {
    font-size: 2rem;
    text-align:center;
  }
`

const Wrapper = styled.div`
  padding:100px 0;
  display:flex;
  flex-direction:column;
  align-items:center;
`;